import { render, staticRenderFns } from "./Box-Three-Columns.vue?vue&type=template&id=81c44ae6&scoped=true&"
import script from "./Box-Three-Columns.vue?vue&type=script&lang=js&"
export * from "./Box-Three-Columns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c44ae6",
  null
  
)

export default component.exports